webpackJsonp([3360190947491456000],{

/***/ "./src/pages/work/dlgsc/img/1.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.c0ec5156.png";

/***/ }),

/***/ "./src/pages/work/dlgsc/img/2.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.5c86dd2d.png";

/***/ }),

/***/ "./src/pages/work/dlgsc/img/3.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.a9a50d6b.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/shoaib/code/decision-labs.com/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-env/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/work/dlgsc/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projects = __webpack_require__("./src/data/projects.js");
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _carousel = __webpack_require__("./src/components/carousel/index.jsx");
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _iphone = __webpack_require__("./src/components/iphone/index.jsx");
	
	var _iphone2 = _interopRequireDefault(_iphone);
	
	var _macbook = __webpack_require__("./src/components/macbook/index.jsx");
	
	var _macbook2 = _interopRequireDefault(_macbook);
	
	var _outboundLink = __webpack_require__("./src/components/outbound-link/index.jsx");
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _wrapper = __webpack_require__("./src/components/wrapper/index.jsx");
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _project = __webpack_require__("./src/components/project/index.js");
	
	var _stylesModule = __webpack_require__("./src/pages/work/dlgsc/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = {
	  desktop: [{ src: __webpack_require__("./src/pages/work/dlgsc/img/1.png"), description: "DLGSC (screenshot 1)" }, { src: __webpack_require__("./src/pages/work/dlgsc/img/2.png"), description: "DLGSC (screenshot 2)" }, { src: __webpack_require__("./src/pages/work/dlgsc/img/3.png"), description: "DLGSC (screenshot 3)" }],
	  mobile: [{ src: __webpack_require__("./src/pages/work/dlgsc/img/1.png"), description: "kindyNow centre detail rooms" }]
	};
	
	var Cityatlas = function Cityatlas(_ref) {
	  var location = _ref.location;
	
	  var project = _projects2.default.find(function (p) {
	    return p.slug === "dlgsc";
	  });
	
	  var image = _react2.default.createElement(
	    "div",
	    { className: _stylesModule2.default.image },
	    _react2.default.createElement("img", { src: project.cover || images["desktop"][0]["src"], alt: "Cover" })
	  );
	
	  var iphone = _react2.default.createElement(
	    _iphone2.default,
	    { invert: true },
	    _react2.default.createElement(_carousel2.default, { images: images.mobile })
	  );
	
	  return _react2.default.createElement(
	    _project.ProjectPage,
	    { project: project, location: location },
	    _react2.default.createElement(_project.ProjectIntro, { project: project, media: image }),
	    _react2.default.createElement(
	      _wrapper2.default,
	      null,
	      _react2.default.createElement(
	        _macbook2.default,
	        null,
	        _react2.default.createElement(_carousel2.default, { images: images.desktop })
	      )
	    )
	  );
	};
	
	exports.default = Cityatlas;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/work/dlgsc/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "._1nkRDvQO4KImxQaNrDyTFF{max-width:50%;margin:0 auto}", ""]);
	
	// exports
	exports.locals = {
		"image": "_1nkRDvQO4KImxQaNrDyTFF"
	};

/***/ }),

/***/ "./src/pages/work/dlgsc/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/work/dlgsc/styles.module.css");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("./node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../../node_modules/postcss-loader/index.js!./styles.module.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../../node_modules/postcss-loader/index.js!./styles.module.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-dlgsc-index-jsx-1eca3454034e4e2aa3ea.js